// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { tenantIsStellantis } from '../utils/utils';
import { environment } from 'src/environments/environment';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    public companyImage: string = null;
    public productImage: string = null;
    public year = new Date().getFullYear();
    public isProd: boolean = environment.production;
    versionNumber = '';

    constructor(
        private readonly userService: UserService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly settingsService: SettingsService
    ) {}

    ngOnInit(): void {
        if (!this.router.url.includes('/login/code') && !this.router.url.includes('/get-started')) {
            // This is causing a force redirect back to the login page
            this.userService.logOut();
        }

        this.setImages();
        this.settingsService.oemCodeEvent().subscribe((oemCode) => {
            this.setImages(oemCode);
        });

        if ((this.route.snapshot.data?.version || []).length > 0) {
            this.versionNumber = this.route.snapshot.data?.version[0]?.versionNumber;
        }
    }

    private setImages(oemCode: string = null): void {
        if (tenantIsStellantis(oemCode)) {
            this.companyImage = '../../assets/img/stellantis-logo-white.png';
            this.productImage = '../../assets/img/ez-docs-logo-white.png';
        } else {
            this.companyImage = '../../assets/img/1-ez-docs-white.png';
            this.productImage = '../../assets/img/cropped-ud-logo-white.png';
        }
    }

    public viewPrivacy(): void {
        window.open('/agreements/PrivacyPolicy', '_blank');
    }

    public viewTandC(): void {
        window.open('/agreements/EndUserAgreement', '_blank');
    }
}
